import React from 'react';
import {
    EntityType,
    Owner,
    GlobalTags,
    GlossaryTerms,
    Domain,
    EntityPath,
    CustomPropertiesEntry,
    Maybe,
} from '../../../../types.generated';
import DefaultPreviewCard from '../../../preview/DefaultPreviewCard';
import { useEntityRegistry } from '../../../useEntityRegistry';
import { IconStyleType } from '../../Entity';

interface Props {
    urn: string;
    name: string;
    description?: string | null;
    owners?: Array<Owner> | null;
    domain?: Domain | null;
    globalTags?: GlobalTags | null;
    glossaryTerms?: GlossaryTerms | null;
    entityCount?: number;
    externalUrl?: string | null;
    degree?: number;
    paths?: EntityPath[];
    governanceStatus?: any;
    customProperties?: Maybe<CustomPropertiesEntry[]>;
    readOnly?: boolean;
}

export const Preview = ({
    urn,
    name,
    description,
    owners,
    globalTags,
    domain,
    glossaryTerms,
    entityCount,
    externalUrl,
    degree,
    paths,
    governanceStatus,
    customProperties,
    readOnly,
}: Props): JSX.Element => {
    const entityRegistry = useEntityRegistry();

    return (
        <DefaultPreviewCard
            url={entityRegistry.getEntityUrl(EntityType.DataProduct, urn)}
            name={name || ''}
            urn={urn}
            description={description || ''}
            type={entityRegistry.getEntityName(EntityType.DataProduct)}
            typeIcon={entityRegistry.getIcon(EntityType.DataProduct, 12, IconStyleType.ACCENT)}
            qualifier={origin}
            tags={globalTags || undefined}
            owners={owners}
            domain={domain}
            glossaryTerms={glossaryTerms || undefined}
            entityCount={entityCount}
            externalUrl={externalUrl}
            displayAssetCount
            degree={degree}
            paths={paths}
            governanceStatus={governanceStatus}
            customProperties={customProperties}
            readOnly={readOnly}
        />
    );
};
